module.exports = __webpack_public_path__ + "static/media/HK.a94141ba.svg";